import { Typography } from "antd";
import { ReactNode } from "react";

type Props = {
  durationMs: string | number | null | undefined;
  size?: "small" | "default";
  showLabel?: boolean;
  label?: string | ReactNode;
};

const CallDuration = (props: Props) => {
  const {
    durationMs,
    size = "default",
    showLabel = false,
    label = "Duration",
  } = props;

  if (!durationMs || Number(durationMs) <= 0) {
    return <Typography.Text type="secondary">-</Typography.Text>;
  }

  const durationInSeconds = Math.round(Number(durationMs) / 1000);
  const fontSize = size === "small" ? 12 : 14;

  return (
    <Typography.Text type="secondary" style={{ fontSize }}>
      {showLabel && (
        <>
          {typeof label === "string" ? label : label}
          {": "}
        </>
      )}
      {durationInSeconds}s
    </Typography.Text>
  );
};

export default CallDuration;
